import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const followingImporterSelectors = importerSelectors(
  'following.importer',
);

export default followingImporterSelectors;
